<app-login-form
  (loginEvent)="handleFormSubmit($event)"
  (forgotPasswordEvent)="resetPassword($event)"
  [loading]="loading"
/>
<p-toast />
